import { lazy } from "react"
export function lazyWithPreload(factory) {
  const Component = lazy(factory)
  return { ...Component, preload: factory } as any as typeof Component & {
    preload: typeof factory
  }
}
